import React from 'react'

const Careers = () => {
  return (
    <div>Not Added yet Careers</div>
  )
}

export default Careers